<script>
  import { Navigate } from "svelte-router-spa";
  import ProductMenu from "../components/ProductMenu.svelte";
  import { currentProduct } from "../stores/product";
  import { Image, Badge } from "../components/display";
  import { navigateTo } from "svelte-router-spa";

  import {
    companyAndPeople,
    competitors,
    buyerPersona,
    productDetails,
    websites,
    landingPages,
    successStories,
    presentation,
    launches,
    emailSeries,
    product
  } from "../content/Icons";
  import Icon from "svelte-awesome";
  import {
    faChevronLeft,
    faChevronRight
  } from "@fortawesome/free-solid-svg-icons";
  import { fly, fade, slide } from "svelte/transition";
  import { quintOut } from "svelte/easing";

  export let isMobile;
  let isExpand = true;

  let src = "/favicon.png";

  let nav = [
    {
      name: `Input`,
      shortCode: `In`,
      items: [
        {
          name: `Product & Features`,
          svg: productDetails,
          link: { first: `/product/`, second: `/product-details` }
        },
        {
          name: `Buyer Persona`,
          svg: buyerPersona,
          link: { first: `/product/`, second: `/buyer-personas` }
        },
        {
          name: `Competitors`,
          svg: competitors,
          link: { first: `/product/`, second: `/competitors` }
        }
      ]
    },
    {
      name: `Output`,
      shortCode: `Out`,
      items: [
        {
          name: `Websites`,
          svg: websites,
          link: { first: `/product/`, second: `/websites` }
        },
        {
          name: `Landing Pages`,
          svg: landingPages,
          link: { first: `/product/`, second: `/landing-pages` }
        },
        {
          name: `Success Stories`,
          svg: successStories,
          link: { first: `/product/`, second: `/sucess-stories` }
        },
        {
          name: `Presentations`,
          svg: presentation,
          link: { first: `/product/`, second: `/presentation` },
          isSoon: true
        }
      ]
    },
    {
      name: `Campaigns`,
      shortCode: `C`,
      items: [
        {
          name: `Launches`,
          svg: launches,
          link: { first: `/product/`, second: `/launches` }
        },
        {
          name: `Email Series`,
          svg: emailSeries,
          link: { first: `/product/`, second: `/email-series` },
          isSoon: true
        }
      ]
    }
  ];

  function goTo(item) {
    const link = `${item.link.first}${
      item.link.second != null
        ? ($currentProduct != null ? $currentProduct.uid : "") +
          item.link.second
        : ""
    }`;
    navigateTo(link);
  }

  // const logoTexts = [
  //   {
  //     //GETITOUT
  //     viewBox: `0 0 525 96`,
  //     paths: [
  //     `M11 35.4859C11 28.4366 12.6208 10 37.4737 10C59.6251 10 62.8668 24.6408 63.4071 32.7746C63.4071 34.4014 62.3265 36.0282 60.7057 36.0282L48.8195 38.7394C46.6584 39.2817 45.5779 38.1972 45.5779 36.0282C45.0376 31.1479 43.4168 27.8944 37.4737 27.8944C29.9098 27.8944 29.3695 32.7746 29.3695 40.9085V56.0916C29.3695 64.2254 29.9098 69.1056 37.4737 69.1056C45.0376 69.1056 45.5779 64.2254 45.5779 59.3451H39.6348C37.4737 59.3451 36.3931 58.2606 36.3931 56.0916V47.4155C36.3931 45.2465 37.4737 44.162 39.6348 44.162H60.7057C62.8668 44.162 63.9474 45.2465 63.9474 47.4155V61.5141C63.9474 68.5634 62.3265 87 37.4737 87C12.6208 87 11 68.5634 11 61.5141V35.4859Z`,
  //     `M119.596 11.6268C121.757 11.6268 122.838 12.7113 122.838 14.8803V26.8099C122.838 28.9789 121.757 30.0634 119.596 30.0634H94.203C92.0419 30.0634 90.9613 31.1479 90.9613 33.3169V36.5704C90.9613 38.7394 92.0419 39.8239 94.203 39.8239H110.411C112.572 39.8239 113.653 40.9084 113.653 42.5352V54.4648C113.653 56.6338 112.572 57.7183 110.411 57.7183H94.203C92.0419 57.7183 90.9613 58.8028 90.9613 60.9718V64.2254C90.9613 66.3944 92.0419 67.4789 94.203 67.4789H119.596C121.757 67.4789 122.838 68.5634 122.838 70.7324V82.662C122.838 84.831 121.757 85.9155 119.596 85.9155H75.8335C73.6724 85.9155 72.5918 84.831 72.5918 82.662V14.8803C72.5918 12.7113 73.6724 11.6268 75.8335 11.6268H119.596V11.6268Z`,
  //     `M148.771 33.3169C148.771 31.1479 147.691 30.0634 145.53 30.0634H130.942C128.781 30.0634 127.7 28.9789 127.7 26.8099V14.8803C127.7 12.7113 128.781 11.6268 130.942 11.6268H184.43C186.591 11.6268 187.671 12.7113 187.671 14.8803V26.8099C187.671 28.9789 186.591 30.0634 184.43 30.0634H169.842C167.681 30.0634 166.6 31.1479 166.6 33.3169V82.662C166.6 84.831 165.52 85.9155 163.359 85.9155H151.473C149.312 85.9155 148.231 84.831 148.231 82.662V33.3169H148.771Z`,
  //     `M234.676 11.6268C236.837 11.6268 237.917 12.7113 237.917 14.8803V82.1197C237.917 84.2887 236.837 85.3732 234.676 85.3732H223.33C221.169 85.3732 220.088 84.2887 220.088 82.1197V14.8803C220.088 12.7113 221.169 11.6268 223.33 11.6268H234.676V11.6268Z`,
  //     `M387.034 61.5141C387.034 68.5634 385.413 87 360.561 87C335.708 87 334.087 68.5634 334.087 61.5141V35.4859C334.087 28.4366 335.708 10 360.561 10C385.413 10 387.034 28.4366 387.034 35.4859V61.5141ZM369.205 40.9085C369.205 32.7746 368.665 27.8944 361.101 27.8944C353.537 27.8944 352.997 32.7746 352.997 40.9085V56.0916C352.997 64.2254 353.537 69.1056 361.101 69.1056C368.665 69.1056 369.205 64.2254 369.205 56.0916V40.9085Z`,
  //     `M410.807 11.6268C412.968 11.6268 414.048 12.7113 414.048 14.8803V56.0916C414.048 64.2254 414.589 69.1056 422.153 69.1056C429.717 69.1056 430.257 64.2254 430.257 56.0916V14.8803C430.257 12.7113 431.337 11.6268 433.498 11.6268H445.385C447.546 11.6268 448.626 12.7113 448.626 14.8803V61.5141C448.626 68.5634 447.005 87 422.153 87C397.3 87 395.679 68.5634 395.679 61.5141V14.8803C395.679 12.7113 396.759 11.6268 398.921 11.6268H410.807V11.6268Z`,
  //     `M475.1 33.3169C475.1 31.1479 474.019 30.0634 471.858 30.0634H457.271C455.11 30.0634 454.029 28.9789 454.029 26.8099V14.8803C454.029 12.7113 455.11 11.6268 457.271 11.6268H510.758C512.919 11.6268 514 12.7113 514 14.8803V26.8099C514 28.9789 512.919 30.0634 510.758 30.0634H496.171C494.01 30.0634 492.929 31.1479 492.929 33.3169V82.662C492.929 84.831 491.849 85.9155 489.687 85.9155H477.801C475.64 85.9155 474.56 84.831 474.56 82.662V33.3169H475.1Z`,
  //     `M264.931 33.3169C264.931 31.1479 263.851 30.0634 261.69 30.0634H247.102C244.941 30.0634 243.86 28.9789 243.86 26.8099V14.8803C243.86 12.7113 244.941 11.6268 247.102 11.6268H300.59C302.751 11.6268 303.831 12.7113 303.831 14.8803V26.8099C303.831 28.9789 302.751 30.0634 300.59 30.0634H286.542C284.381 30.0634 283.301 31.1479 283.301 33.3169V82.662C283.301 84.831 282.22 85.9155 280.059 85.9155H268.173C266.012 85.9155 264.931 84.831 264.931 82.662V33.3169V33.3169Z`]
  //   },
  //   {
  //     //GET-it-OUT-v1
  //     viewBox: `0 0 570 96`,
  //     paths :[
  //       `M72.8627 79.0816C66.8114 85.1429 59.1098 88.449 50.858 88.449C45.9069 88.449 40.9558 87.3469 36.5549 85.1429C32.1539 82.9388 28.3031 80.1837 25.0024 76.8776C21.7017 73.0204 18.9511 69.1633 17.3007 64.2041C15.6504 59.2449 14 53.7347 14 48.2245C14 42.7143 15.1002 37.7551 16.7506 32.7959C18.9511 28.3878 21.7017 23.9796 25.0024 20.6735C28.3031 17.3673 32.704 14.0612 37.105 12.4082C41.5059 10.7551 47.0071 9.10204 51.9582 9.10204C59.1098 9.10204 65.7112 10.7551 70.6623 13.5102C76.1634 16.8163 80.0143 20.6735 82.2148 26.1837L70.6623 34.449C68.4618 30.5918 65.7112 27.8367 62.4105 25.6327C59.6599 23.4286 55.809 22.3265 51.4081 22.3265C48.1074 22.3265 45.3568 22.8776 42.6062 24.5306C39.8556 25.6327 37.105 27.8367 35.4546 30.0408C33.2542 32.7959 32.1539 35.551 31.0537 38.8571C29.9534 42.1633 29.4033 44.9184 29.4033 48.7755C29.4033 52.6327 29.9534 55.9388 31.0537 59.2449C32.1539 62.551 33.8043 65.3061 36.0048 67.5102C38.2052 69.7143 40.4057 71.9184 43.1563 73.0204C45.9069 74.1225 49.2076 74.6735 52.5083 74.6735C60.21 74.6735 66.8114 71.3674 72.8627 64.2041V58.6939H56.9093V47.6735H85.5155V87.898H72.8627V79.0816Z`,
  //       `M152.63 74.6735V87.898H98.1682V9.65306H151.53V22.8775H113.572V41.6122H146.579V53.7347H113.572V74.1224H152.63V74.6735Z`,
  //       `M223.045 22.8775H198.29V87.898H183.437V22.8775H158.681V9.65306H223.045V22.8775Z`,
  //       `M364.426 88.449C358.925 88.449 353.423 87.3469 349.022 85.1429C344.621 82.9388 340.221 80.1837 336.92 76.3265C333.619 72.4694 330.869 68.6123 329.218 63.6531C327.568 58.6939 326.468 53.7347 326.468 48.7755C326.468 43.8163 327.568 38.3061 329.218 33.898C331.419 28.9388 333.619 25.0816 337.47 21.2245C340.771 17.3673 345.172 14.6122 349.573 12.4082C354.524 10.2041 359.475 9.10204 364.976 9.10204C370.477 9.10204 375.978 10.2041 380.379 12.4082C384.78 14.6122 389.181 17.9184 392.482 21.2245C395.783 24.5306 398.533 29.4898 400.183 33.898C401.834 38.8571 402.934 43.2653 402.934 48.2245C402.934 53.1837 401.834 58.6939 400.183 63.102C398.533 67.5102 395.783 71.9184 392.482 75.7755C389.181 79.6327 385.33 82.3878 380.379 84.5918C374.878 87.3469 369.927 88.449 364.426 88.449ZM341.871 48.7755C341.871 52.0816 342.421 55.3878 343.521 58.6939C344.621 62 346.272 64.7551 347.922 66.9592C350.123 69.1633 352.323 71.3674 355.074 73.0204C357.824 74.6735 361.125 75.2245 364.976 75.2245C368.827 75.2245 372.127 74.6735 374.878 73.0204C377.629 71.3674 379.829 69.7143 382.03 66.9592C384.23 64.2041 385.33 61.449 386.431 58.6939C387.531 55.3878 388.081 52.6327 388.081 49.3265C388.081 46.0204 387.531 42.7143 386.431 39.4082C385.33 36.102 383.68 33.3469 382.03 31.1429C380.379 28.9388 376.528 26.1837 373.778 24.5306C371.027 22.8776 367.726 22.3265 364.426 22.3265C360.575 22.3265 357.274 22.8776 354.524 24.5306C351.773 26.1837 349.022 27.8367 347.372 30.5918C345.722 32.7959 344.071 36.102 342.971 38.8571C341.871 42.1633 341.871 45.4694 341.871 48.7755Z`,
  //       `M446.944 74.6735C450.794 74.6735 453.545 74.1224 455.746 72.4694C457.946 70.8163 460.146 69.1633 461.797 66.9592C463.447 64.7551 464.547 62 465.098 58.6939C465.648 55.3877 466.198 52.6326 466.198 49.3265V9.65306H481.601V49.3265C481.601 54.8367 481.051 59.7959 479.401 64.2041C478.3 69.1633 476.1 73.0204 473.349 76.3265C470.599 79.6326 467.298 82.3877 462.897 84.5918C458.496 86.7959 453.545 87.898 447.494 87.898C441.442 87.898 435.941 86.7959 431.54 84.5918C427.139 82.3877 423.839 79.6326 421.088 75.7755C418.337 72.4694 416.687 68.0612 415.037 63.102C413.936 58.1428 413.386 53.7347 413.386 48.2245V9.65306H428.79V49.3265C428.79 52.6326 429.34 55.9388 429.89 58.6939C430.44 61.449 431.54 64.2041 433.191 66.9592C434.841 69.7143 436.491 71.3673 439.242 72.4694C440.892 74.1224 443.643 74.6735 446.944 74.6735Z`,
  //       `M555.317 22.8775H530.562V87.898H515.708V22.8775H490.953V9.65306H555.867V22.8775H555.317Z`,
  //       `M254.952 31.1429H264.854L252.752 88.449H242.849L254.952 31.1429ZM259.353 8H269.255L266.505 20.1224H256.602L259.353 8Z`,
  //       `M282.458 89C279.707 89 276.957 88.449 275.307 86.7959C273.106 85.1429 272.556 82.9388 272.556 80.1837C272.556 79.0816 272.556 77.9796 273.106 76.8776L281.358 38.3061H273.656L275.307 30.5918H282.458L286.309 11.3061H296.211L292.36 30.5918H304.463L302.812 38.3061H290.71L283.008 74.1224C283.008 74.6735 283.008 75.2245 283.008 75.7755C283.008 77.4286 283.558 78.5306 284.659 79.0816C285.759 79.6327 286.859 80.1837 287.959 80.1837C289.61 80.1837 291.26 79.6327 292.91 79.0816C294.561 78.5306 295.661 77.9796 296.211 77.4286L296.761 85.1429C295.661 86.2449 293.46 86.7959 290.71 87.898C287.959 89 285.209 89 282.458 89Z`
  //     ]
  //   },
  //     {
  //     //GET-it-OUT-v2
  //     viewBox: `0 0 515 78`,
  //     paths :[
  //       `M57.6499 68.449C51.7233 74.2857 44.1803 77.4694 36.0985 77.4694C31.2495 77.4694 26.4004 76.4082 22.0901 74.2857C17.7799 72.1633 14.0084 69.5102 10.7757 66.3265C7.54298 62.6123 4.84906 58.898 3.2327 54.1225C1.61635 49.3469 0 44.0408 0 38.7347C0 33.4286 1.07757 28.6531 2.69392 23.8776C4.84906 19.6327 7.54298 15.3878 10.7757 12.2041C14.0084 9.02041 18.3187 5.83674 22.6289 4.2449C26.9392 2.65306 32.327 1.06123 37.1761 1.06123C44.1803 1.06123 50.6457 2.65306 55.4948 5.30612C60.8826 8.4898 64.6541 12.2041 66.8092 17.5102L55.4948 25.4694C53.3396 21.7551 50.6457 19.102 47.413 16.9796C44.7191 14.8571 40.9476 13.7959 36.6373 13.7959C33.4046 13.7959 30.7107 14.3265 28.0168 15.9184C25.3229 16.9796 22.6289 19.102 21.0126 21.2245C18.8574 23.8776 17.7799 26.5306 16.7023 29.7143C15.6247 32.898 15.086 35.551 15.086 39.2653C15.086 42.9796 15.6247 46.1633 16.7023 49.3469C17.7799 52.5306 19.3962 55.1837 21.5514 57.3061C23.7065 59.4286 25.8616 61.551 28.5556 62.6123C31.2495 63.6735 34.4822 64.2041 37.7149 64.2041C45.2579 64.2041 51.7233 61.0204 57.6499 54.1225V48.8163H42.0252V38.2041H70.0419V76.9388H57.6499V68.449Z`,
  //       `M135.774 64.2041V76.9388H82.434V1.59184H134.696V14.3265H97.5199V32.3673H129.847V44.0408H97.5199V63.6735H135.774V64.2041Z`,
  //       `M204.738 14.3265H180.493V76.9388H165.946V14.3265H141.7V1.59184H204.738V14.3265Z`,
  //       `M327.042 77.4694C321.654 77.4694 316.266 76.4082 311.956 74.2857C307.646 72.1633 303.335 69.5102 300.103 65.7959C296.87 62.0816 294.176 58.3674 292.56 53.5918C290.943 48.8163 289.866 44.0408 289.866 39.2653C289.866 34.4898 290.943 29.1837 292.56 24.9388C294.715 20.1633 296.87 16.449 300.641 12.7347C303.874 9.02041 308.184 6.36735 312.495 4.2449C317.344 2.12245 322.193 1.06123 327.581 1.06123C332.969 1.06123 338.356 2.12245 342.667 4.2449C346.977 6.36735 351.287 9.55102 354.52 12.7347C357.753 15.9184 360.447 20.6939 362.063 24.9388C363.679 29.7143 364.757 33.9592 364.757 38.7347C364.757 43.5102 363.679 48.8163 362.063 53.0612C360.447 57.3061 357.753 61.551 354.52 65.2653C351.287 68.9796 347.516 71.6327 342.667 73.7551C337.279 76.4082 332.43 77.4694 327.042 77.4694ZM304.952 39.2653C304.952 42.449 305.491 45.6327 306.568 48.8163C307.646 52 309.262 54.6531 310.878 56.7755C313.034 58.898 315.189 61.0204 317.883 62.6123C320.577 64.2041 323.809 64.7347 327.581 64.7347C331.352 64.7347 334.585 64.2041 337.279 62.6123C339.973 61.0204 342.128 59.4286 344.283 56.7755C346.438 54.1225 347.516 51.4694 348.593 48.8163C349.671 45.6327 350.21 42.9796 350.21 39.7959C350.21 36.6122 349.671 33.4286 348.593 30.2449C347.516 27.0612 345.899 24.4082 344.283 22.2857C342.667 20.1633 338.895 17.5102 336.201 15.9184C333.507 14.3265 330.275 13.7959 327.042 13.7959C323.27 13.7959 320.038 14.3265 317.344 15.9184C314.65 17.5102 311.956 19.102 310.34 21.7551C308.723 23.8776 307.107 27.0612 306.029 29.7143C304.952 32.898 304.952 36.0816 304.952 39.2653Z`,
  //       `M407.86 64.2041C411.631 64.2041 414.325 63.6735 416.48 62.0816C418.635 60.4898 420.79 58.898 422.407 56.7755C424.023 54.6531 425.101 52 425.639 48.8163C426.178 45.6327 426.717 42.9796 426.717 39.7959V1.59184H441.803V39.7959C441.803 45.102 441.264 49.8776 439.648 54.1224C438.57 58.898 436.415 62.6122 433.721 65.7959C431.027 68.9796 427.795 71.6327 423.484 73.7551C419.174 75.8776 414.325 76.9388 408.398 76.9388C402.472 76.9388 397.084 75.8776 392.774 73.7551C388.463 71.6327 385.231 68.9796 382.537 65.2653C379.843 62.0816 378.226 57.8367 376.61 53.0612C375.533 48.2857 374.994 44.0408 374.994 38.7347V1.59184H390.08V39.7959C390.08 42.9796 390.618 46.1633 391.157 48.8163C391.696 51.4694 392.774 54.1224 394.39 56.7755C396.006 59.4286 397.623 61.0204 400.317 62.0816C401.933 63.6735 404.627 64.2041 407.86 64.2041Z`,
  //       `M514 14.3265H489.755V76.9388H475.208V14.3265H450.962V1.59184H514.539V14.3265H514Z`,
  //       `M226.828 22.2857H236.526L224.673 77.4694H214.975L226.828 22.2857ZM231.677 0H241.375L238.681 11.6735H228.983L231.677`,
  //       `M254.306 78C251.612 78 248.918 77.4694 247.302 75.8775C245.147 74.2857 244.608 72.1633 244.608 69.5102C244.608 68.449 244.608 67.3878 245.147 66.3265L253.228 29.1837H245.685L247.302 21.7551H254.306L258.078 3.18367H267.776L264.004 21.7551H275.857L274.241 29.1837H262.388L254.306 63.6735C254.306 64.2041 254.306 64.7347 254.306 65.2653C254.306 66.8571 254.845 67.9184 255.922 68.449C257 68.9796 258.078 69.5102 259.155 69.5102C260.771 69.5102 262.388 68.9796 264.004 68.449C265.62 67.9184 266.698 67.3878 267.237 66.8571L267.776 74.2857C266.698 75.3469 264.543 75.8775 261.849 76.9388C259.694 78 257 78 254.306 78Z`
  //     ]
  //   },
  //     {
  //     //GET-it-OUT-v3
  //     viewBox: `0 0 525 96`,
  //     paths :[
  //       `M63.7698 79.0816C57.728 85.1429 50.0385 88.449 41.7998 88.449C36.8565 88.449 31.9133 87.3469 27.5193 85.1429C23.1253 82.9388 19.2805 80.1837 15.985 76.8776C12.6895 73.0204 9.94325 69.1633 8.2955 64.2041C6.64775 59.2449 5 53.7347 5 48.2245C5 42.7143 6.0985 37.7551 7.74625 32.7959C9.94325 28.3878 12.6895 23.9796 15.985 20.6735C19.2805 17.3673 23.6745 14.0612 28.0685 12.4082C32.4625 10.7551 37.955 9.10204 42.8983 9.10204C50.0385 9.10204 56.6295 10.7551 61.5728 13.5102C67.0653 16.8163 70.9101 20.6735 73.1071 26.1837L61.5728 34.449C59.3758 30.5918 56.6295 27.8367 53.334 25.6327C50.5878 23.4286 46.743 22.3265 42.349 22.3265C39.0535 22.3265 36.3073 22.8776 33.561 24.5306C30.8148 25.6327 28.0685 27.8367 26.4208 30.0408C24.2238 32.7959 23.1253 35.551 22.0268 38.8571C20.9283 42.1633 20.379 44.9184 20.379 48.7755C20.379 52.6327 20.9283 55.9388 22.0268 59.2449C23.1253 62.551 24.773 65.3061 26.97 67.5102C29.167 69.7143 31.364 71.9184 34.1103 73.0204C36.8565 74.1225 40.152 74.6735 43.4475 74.6735C51.137 74.6735 57.728 71.3674 63.7698 64.2041V58.6939H47.8415V47.6735H76.4026V87.898H63.7698V79.0816Z`,
  //       `M143.411 74.6735V87.898H89.0353V9.65306H142.313V22.8775H104.414V41.6122H137.369V53.7347H104.414V74.1224H143.411V74.6735Z`,
  //       `M213.715 22.8775H188.999V87.898H174.169V22.8775H149.453V9.65306H213.715V22.8775Z`,
  //       `M327.41 88.449C321.918 88.449 316.425 87.3469 312.031 85.1429C307.637 82.9388 303.243 80.1837 299.948 76.3265C296.652 72.4694 293.906 68.6123 292.258 63.6531C290.61 58.6939 289.512 53.7347 289.512 48.7755C289.512 43.8163 290.61 38.3061 292.258 33.898C294.455 28.9388 296.652 25.0816 300.497 21.2245C303.792 17.3673 308.186 14.6122 312.58 12.4082C317.524 10.2041 322.467 9.10204 327.959 9.10204C333.452 9.10204 338.944 10.2041 343.338 12.4082C347.732 14.6122 352.126 17.9184 355.422 21.2245C358.717 25.0816 361.464 29.4898 363.111 33.898C364.759 38.8571 365.858 43.2653 365.858 48.2245C365.858 53.1837 364.759 58.6939 363.111 63.102C361.464 67.5102 358.717 71.9184 355.422 75.7755C352.126 79.6327 348.282 82.3878 343.338 84.5918C337.846 87.3469 332.903 88.449 327.41 88.449ZM304.891 48.7755C304.891 52.0816 305.44 55.3878 306.539 58.6939C307.637 62 309.285 64.7551 310.933 66.9592C313.13 69.1633 315.327 71.3674 318.073 73.0204C320.819 74.6735 324.115 75.2245 327.959 75.2245C331.804 75.2245 335.1 74.6735 337.846 73.0204C340.592 71.3674 342.789 69.7143 344.986 66.9592C347.183 64.2041 348.282 61.449 349.38 58.6939C350.479 55.3878 351.028 52.6327 351.028 49.3265C351.028 46.0204 350.479 42.7143 349.38 39.4082C348.282 36.102 346.634 33.3469 344.986 31.1429C343.338 28.9388 339.494 26.1837 336.747 24.5306C334.001 22.8776 330.706 22.3265 327.41 22.3265C323.565 22.3265 320.27 22.8776 317.524 24.5306C314.777 26.1837 312.031 27.8367 310.383 30.5918C308.736 32.7959 307.088 36.102 305.989 38.8571C304.891 42.1633 304.891 45.4694 304.891 48.7755Z`,
  //       `M409.798 74.6735C413.642 74.6735 416.389 74.1224 418.586 72.4694C420.783 70.8163 422.98 69.1633 424.627 66.9592C426.275 64.7551 427.374 62 427.923 58.6939C428.472 55.3877 429.021 52.6326 429.021 49.3265V9.65306H444.4V49.3265C444.4 54.8367 443.851 59.7959 442.203 64.2041C441.105 69.1633 438.908 73.0204 436.162 76.3265C433.415 79.6326 430.12 82.3877 425.726 84.5918C421.332 86.7959 416.389 87.898 410.347 87.898C404.305 87.898 398.813 86.7959 394.419 84.5918C390.025 82.3877 386.729 79.6326 383.983 75.7755C381.237 72.4694 379.589 68.0612 377.941 63.102C376.843 58.1428 376.293 53.7347 376.293 48.2245V9.65306H391.672V49.3265C391.672 52.6326 392.222 55.9388 392.771 58.6939C393.32 61.449 394.419 64.2041 396.066 66.9592C397.714 69.7143 399.362 71.3673 402.108 72.4694C403.756 74.1224 406.502 74.6735 409.798 74.6735Z`,
  //       `M518 22.8775H493.284V87.898H478.454V22.8775H453.738V9.65306H518.549V22.8775H518Z`,
  //       `M229.094 31.1429H238.981L226.897 88.449H217.011L229.094 31.1429ZM233.488 8H243.375L240.628 20.1224H230.742L233.488 8Z`,
  //       `M256.557 89C253.81 89 251.064 88.449 249.416 86.7959C247.219 85.1429 246.67 82.9388 246.67 80.1837C246.67 79.0816 246.67 77.9796 247.219 76.8776L255.458 38.3061H247.769L249.416 30.5918H256.557L260.401 11.3061H270.288L266.443 30.5918H278.527L276.879 38.3061H264.795L257.106 74.1225C257.106 74.6735 257.106 75.2245 257.106 75.7755C257.106 77.4286 257.655 78.5306 258.754 79.0816C259.852 79.6327 260.951 80.1837 262.049 80.1837C263.697 80.1837 265.345 79.6327 266.993 79.0816C268.64 78.5306 269.739 77.9796 270.288 77.4286L270.837 85.1429C269.739 86.2449 267.542 86.7959 264.795 87.898C262.049 89 259.303 89 256.557 89Z`,
  //     ]
  //   }
  // ]

  // const logos = [
  //   {
  //     //Layout SIMPLE Gray
  //     class: `mr-2 ml-1`,
  //     viewBox: `0 0 67 78`,
  //     paths:[
  //       {fill: `white`, d: `M61.2062 16.955H4.98519C3.49259 16.955 2 15.4602 2 13.9654V6.98962C2 5.49481 3.49259 4 4.98519 4H61.2062C62.6988 4 64.1914 5.49481 64.1914 6.98962V13.9654C63.6938 15.4602 62.6988 16.955 61.2062 16.955Z`},
  //       {fill: `#ECECEC`, d: `M61.2062 74.2561H4.98519C3.49259 74.2561 2 72.7612 2 71.2664V64.2907C2 62.7959 3.49259 61.301 4.98519 61.301H61.2062C62.6988 61.301 64.1914 62.7959 64.1914 64.2907V71.7647C63.6938 73.2595 62.6988 74.2561 61.2062 74.2561Z`},
  //       {fill: `#868686`, d: `M16.4284 36.3875H4.98519C3.49259 36.3875 2 34.8927 2 33.3979V26.4221C2 24.9273 3.49259 23.4325 4.98519 23.4325H16.4284C17.921 23.4325 19.4136 24.9273 19.4136 26.4221V33.3979C19.4136 34.8927 17.921 36.3875 16.4284 36.3875Z`},
  //       {fill: `#AFAFAF`, d: `M16.4284 55.3218H4.98519C3.49259 55.3218 2 53.827 2 52.3322V45.3564C2 43.8616 3.49259 42.3668 4.98519 42.3668H16.4284C17.921 42.3668 19.4136 43.8616 19.4136 45.3564V52.3322C19.4136 54.3253 17.921 55.3218 16.4284 55.3218Z`},
  //       {fill: `#868686`, d: `M38.8173 55.3218H27.3741C25.8815 55.3218 24.3889 53.827 24.3889 52.3322V45.3564C24.3889 43.8616 25.8815 42.3668 27.3741 42.3668H38.8173C40.3099 42.3668 41.8025 43.8616 41.8025 45.3564V52.3322C41.3049 54.3253 40.3099 55.3218 38.8173 55.3218Z`},
  //       {fill: `#B1B1B1`, d: `M61.2062 55.3218H49.763C48.2704 55.3218 46.7778 53.827 46.7778 52.3322V45.3564C46.7778 43.8616 48.2704 42.3668 49.763 42.3668H61.2062C62.6988 42.3668 64.1913 43.8616 64.1913 45.3564V52.3322C63.6938 54.3253 62.6988 55.3218 61.2062 55.3218Z`},
  //       {fill: `#D9D9D9`, d: `M61.2062 36.3875H27.3741C25.8815 36.3875 24.3889 34.8927 24.3889 33.3979V26.4221C24.3889 24.9273 25.8815 23.4325 27.3741 23.4325H61.2062C62.6988 23.4325 64.1914 24.9273 64.1914 26.4221V33.3979C63.6938 34.8927 62.6988 36.3875 61.2062 36.3875Z`}

  //     ]

  //   },
  //   {
  //     //Layout-Gradation Gray
  //     viewBox: `0 0 67 78`,
  //     class: `mr-2 ml-1`,
  //     paths:[
  //       {fill: `url(#icon0_gray)`, d: `M60.7086 16.955H4.98519C3.49259 16.955 2 15.4602 2 13.9654V6.98962C2 5.49481 3.49259 4 4.98519 4H61.2062C62.6988 4 64.1914 5.49481 64.1914 6.98962V13.9654C63.6938 15.4602 62.6988 16.955 60.7086 16.955Z`},
  //       {fill: `url(#icon1_gray)`, d: `M60.7086 74.7543H4.98519C3.49259 74.7543 2 73.2595 2 71.7647V64.7889C2 63.2941 3.49259 61.7993 4.98519 61.7993H61.2062C62.6988 61.7993 64.1914 63.2941 64.1914 64.7889V71.7647C63.6938 73.2595 62.6988 74.7543 60.7086 74.7543Z`},
  //       {fill: `url(#icon2_gray)`, d: `M15.9309 36.3875H4.98519C3.49259 36.3875 2 34.8927 2 33.3979V26.4221C2 24.9273 3.49259 23.4325 4.98519 23.4325H16.4284C17.921 23.4325 19.4136 24.9273 19.4136 26.4221V33.3979C18.916 34.8927 17.921 36.3875 15.9309 36.3875Z`},
  //       {fill: `url(#icon3_gray)`, d: `M15.9309 55.3218H4.98519C3.49259 55.3218 2 54.3253 2 52.3322V45.3564C2 43.8616 3.49259 42.3668 4.98519 42.3668H16.4284C17.921 42.3668 19.4136 43.8616 19.4136 45.3564V52.3322C18.916 54.3253 17.921 55.3218 15.9309 55.3218Z`},
  //       {fill: `url(#icon4_gray)`, d: `M38.3198 55.3218H27.3741C25.8815 55.3218 24.3889 53.827 24.3889 52.3322V45.3564C24.3889 43.8616 25.8815 42.3668 27.3741 42.3668H38.8173C40.3099 42.3668 41.8025 43.8616 41.8025 45.3564V52.3322C41.3049 54.3253 40.3099 55.3218 38.3198 55.3218Z`},
  //       {fill: `url(#icon5_gray)`, d: `M60.7086 55.3218H49.763C48.2704 55.3218 46.7778 54.3253 46.7778 52.3322V45.3564C46.7778 43.8616 48.2704 42.3668 49.763 42.3668H61.2062C62.6988 42.3668 64.1913 43.8616 64.1913 45.3564V52.3322C63.6938 54.3253 62.6988 55.3218 60.7086 55.3218Z`},
  //       {fill: `url(#icon6_gray)`, d: `M60.7086 36.3875H27.3741C25.8815 36.3875 24.3889 34.8927 24.3889 33.3979V26.9204C24.3889 25.4256 25.8815 23.9308 27.3741 23.9308H61.2062C62.6988 23.9308 64.1914 25.4256 64.1914 26.9204V33.8962C63.6938 34.8927 62.6988 36.3875 60.7086 36.3875Z`}
  //     ],
  //     linearGradients:[
  //       {id: `icon0_gray`, x1: `2`, x2: `63.8212`, y1: `10.6175`, y2: `10.6175`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `white`},
  //           {color: `#F1F1F1`, offset: "1"}
  //         ]
  //       },
  //       {id: `icon1_gray`, x1: `2`, x2: `63.8212`, y1: `68.2579`, y2: `68.2579`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#ECECEC`},
  //           {color: `#D3D3D3`, offset: "1"}
  //         ]
  //       },
  //       {id: `icon2_gray`, x1: `2`, x2: `19.0633`, y1: `30.1148`, y2: `30.1148`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#868686`},
  //           {color: `#696969`, offset: "1"}
  //         ]
  //       },
  //       {id: `icon3_gray`, x1: `2`, x2: `19.0633`, y1: `49.1597`, y2: `49.1597`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#AFAFAF`},
  //           {color: `#9A9999`, offset: "1"}
  //         ]
  //       },
  //       {id: `icon4_gray`, x1: `24.3789`, x2: `41.4423`, y1: `49.1597`, y2: `49.1597`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#868686`, offset: "0.296875"},
  //           {color: `#686767`, offset: "1"}
  //         ]
  //       },
  //       {id: `icon5_gray`, x1: `46.7579`, x2: `63.8212`, y1: `49.1597`, y2: `49.1597`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#B1B1B1`, offest: "0.354167"},
  //           {color: `#8A8A8A`, offset: "1"}
  //         ]
  //       },
  //       {id: `icon6_gray`, x1: `24.3789`, x2: `63.8212`, y1: `30.1148`, y2: `30.1148`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#D9D9D9`, offset: "0.4634"},
  //           {color: `#BDBDBD`, offset: "1"}
  //         ]
  //       }
  //     ]

  //   },
  //   {
  //     //Icon-Layout-Simple
  //     viewBox: `0 0 55 63`,
  //     class: `mr-2 ml-1`,
  //     paths:[
  //       {fill: `#F7BC00`, d: `M49.5806 13.0806H4.41935C3.20968 13.0806 2 12.2742 2 11.0645V5.41935C2 4.20968 3.20968 3 4.41935 3H49.9839C51.1935 3 52.4032 4.20968 52.4032 5.41935V11.0645C52 12.2742 51.1935 13.0806 49.5806 13.0806Z`},
  //       {fill: `#93C01F`, d: `M49.5806 59.8548H4.41935C3.20968 59.8548 2 58.6452 2 57.4355V51.7903C2 50.5807 3.20968 49.371 4.41935 49.371H49.9839C51.1935 49.371 52.4032 50.5807 52.4032 51.7903V57.4355C52 58.6452 51.1935 59.8548 49.5806 59.8548Z`},
  //       {fill: `#C90920`, d: `M13.2903 28.8065H4.41935C3.20968 28.8065 2 28 2 26.7903V21.1452C2 19.9355 3.20968 18.7258 4.41935 18.7258H13.6935C14.9032 18.7258 16.1129 19.9355 16.1129 21.1452V26.7903C15.7097 28 14.9032 28.8065 13.2903 28.8065Z`},
  //       {fill: `#00A099`, d: `M13.2903 44.5323H4.41935C3.20968 44.5323 2 43.3226 2 42.1129V36.4677C2 35.2581 3.20968 34.0484 4.41935 34.0484H13.6935C14.9032 34.0484 16.1129 35.2581 16.1129 36.4677V42.1129C15.7097 43.3226 14.9032 44.5323 13.2903 44.5323Z`},
  //       {fill: `#2D2E82`, d: `M31.4355 44.5323H22.5645C21.3548 44.5323 20.1452 43.3226 20.1452 42.1129V36.4677C20.1452 35.2581 21.3548 34.0484 22.5645 34.0484H31.8387C33.0484 34.0484 34.2581 35.2581 34.2581 36.4677V42.1129C33.8548 43.3226 33.0484 44.5323 31.4355 44.5323Z`},
  //       {fill: `#A2195B`, d: `M49.5806 44.5323H40.7097C39.5 44.5323 38.2903 43.3226 38.2903 42.1129V36.4677C38.2903 35.2581 39.5 34.0484 40.7097 34.0484H49.9839C51.1935 34.0484 52.4032 35.2581 52.4032 36.4677V42.1129C52 43.3226 51.1935 44.5323 49.5806 44.5323Z`},
  //       {fill: `#E84E1B`, d: `M49.5806 28.8065H22.5645C21.3548 28.8065 20.1452 27.5968 20.1452 26.3871V21.1452C20.1452 19.9355 21.3548 18.7258 22.5645 18.7258H49.9839C51.1935 18.7258 52.4032 19.9355 52.4032 21.1452V26.7903C52 28 51.1936 28.8065 49.5806 28.8065Z`}

  //     ]
  //   },
  //   {
  //     //Icon-Layout-Gradation
  //     viewBox: `0 0 55 63`,
  //     class: `mr-2 ml-1`,
  //     paths:[
  //       {fill: `url(#icon0)`, d: `M49.5806 13.1064H4.41935C3.20968 13.1064 2 12.2979 2 11.0851V5.42553C2 4.21277 3.20968 3 4.41935 3H49.9839C51.1935 3 52.4032 4.21277 52.4032 5.42553V11.0851C52 12.2979 51.1935 13.1064 49.5806 13.1064Z`},
  //       {fill: `url(#icon1)`, d: `M49.5806 60H4.41935C3.20968 60 2 58.7872 2 57.5745V51.9149C2 50.7021 3.20968 49.4894 4.41935 49.4894H49.9839C51.1935 49.4894 52.4032 50.7021 52.4032 51.9149V57.5745C52 58.7872 51.1935 60 49.5806 60Z`},
  //       {fill: `url(#icon2)`, d: `M13.2903 28.8723H4.41935C3.20968 28.8723 2 28.0638 2 26.8511V21.1915C2 19.9787 3.20968 18.766 4.41935 18.766H13.6935C14.9032 18.766 16.1129 19.9787 16.1129 21.1915V26.8511C15.7097 28.0638 14.9032 28.8723 13.2903 28.8723Z`},
  //       {fill: `url(#icon3)`, d: `M13.2903 44.6383H4.41935C3.20968 44.6383 2 43.4255 2 42.2128V36.5532C2 35.3404 3.20968 34.1277 4.41935 34.1277H13.6935C14.9032 34.1277 16.1129 35.3404 16.1129 36.5532V42.2128C15.7097 43.4255 14.9032 44.6383 13.2903 44.6383Z`},
  //       {fill: `url(#icon4)`, d: `M31.4355 44.6383H22.5645C21.3548 44.6383 20.1452 43.4255 20.1452 42.2128V36.5532C20.1452 35.3404 21.3548 34.1277 22.5645 34.1277H31.8387C33.0484 34.1277 34.2581 35.3404 34.2581 36.5532V42.2128C33.8548 43.4255 33.0484 44.6383 31.4355 44.6383Z`},
  //       {fill: `url(#icon5)`, d: `M49.5806 44.6383H40.7097C39.5 44.6383 38.2903 43.4255 38.2903 42.2128V36.5532C38.2903 35.3404 39.5 34.1277 40.7097 34.1277H49.9839C51.1935 34.1277 52.4032 35.3404 52.4032 36.5532V42.2128C52 43.4255 51.1935 44.6383 49.5806 44.6383Z`},
  //       {fill: `url(#icon6)`, d: `M49.5806 28.8723H22.5645C21.3548 28.8723 20.1452 27.6596 20.1452 26.4468V21.1915C20.1452 19.9787 21.3548 18.766 22.5645 18.766H49.9839C51.1935 18.766 52.4032 19.9787 52.4032 21.1915V26.8511C52 28.0638 51.1936 28.8723 49.5806 28.8723Z`}
  //     ],
  //     linearGradients:[
  //       {id: `icon0`, x1: `2`, x2: `52.1032`, y1: `8.11625`, y2: `8.11625`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#F7BC00`},
  //           {color: `#D8A209`, offset: "1"}
  //         ]
  //       },
  //       {id: `icon1`, x1: `2`, x2: `52.1032`, y1: `54.8809`, y2: `54.8809`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#93C01F`},
  //           {color: `#008D36`, offset: "1"}
  //         ]
  //       },
  //       {id: `icon2`, x1: `2`, x2: `15.829`, y1: `23.9348`, y2: `23.9348`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#C90920`},
  //           {color: `#A0122A`, offset: "1"}
  //         ]
  //       },
  //       {id: `icon3`, x1: `2`, x2: `15.829`, y1: `39.3862`, y2: `39.3862`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#00A099`},
  //           {color: `#2D2E82`, offset: "1"}
  //         ]
  //       },
  //       {id: `icon4`, x1: `20.1371`, x2: `33.9661`, y1: `39.3862`, y2: `39.3862`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#2D2E82`},
  //           {color: `#2C2C7B`, offset: "0.3153"},
  //           {color: `#2A2769`, offset: "0.7619"},
  //           {color: `#29235C`, offset: "1"}

  //         ]
  //       },
  //       {id: `icon5`, x1: `38.2742`, x2: `52.1032`, y1: `39.3862"`, y2: `39.3862`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#D60B51`},
  //           {color: `#A2195B`, offset: "1"}
  //         ]
  //       },
  //       {id: `icon6`, x1: `20.1371`, x2: `52.1032`, y1: `23.9348`, y2: `23.9348`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#E84E1B`, offset: "0.4634"},
  //           {color: `#BA3F1E`, offset: "1"}
  //         ]
  //       }
  //     ]

  //   },
  //   {
  //     //ROCKET SIMPLE Gray
  //     class: `mr-1 ml-2`,
  //     viewBox: `0 0 114 156`,
  //     paths:[
  //       {fill: `#C90920`, d: `M95.9118 20.2675L103.166 9L95.9118 20.2675C95.7575 20.2675 95.9118 20.2675 95.9118 20.2675Z`},
  //       {fill: `#D9D9D9`, d: `M55.0092 25.5154C53.4657 26.9045 48.0635 31.2263 43.2787 48.3591L50.8418 54.9961C56.244 38.6351 60.5658 33.0785 61.1832 32.4611C65.3506 28.9111 82.9465 23.5089 95.9118 20.2675L103.012 9L98.3814 10.0804C92.5162 11.4696 62.8811 18.8784 55.0092 25.5154Z`},
  //       {fill: `#868686`, d: `M43.5874 79.5377C43.8961 78.4573 44.2048 76.9138 44.6678 75.3703L45.7483 71.3572L41.8895 69.8137C39.883 69.0419 35.5612 67.8071 30.622 68.8876C31.3938 66.2636 32.7829 63.6397 34.9438 61.4788C37.7221 58.7005 41.5808 57.4657 46.52 57.6201L49.9157 57.7744L52.8483 49.1309C51.9222 48.8222 47.9092 48.2048 43.2787 48.5135C37.259 48.9765 32.3199 51.1374 28.4611 54.9961C19.9719 63.331 20.1263 76.6051 20.1263 77.2225L27.6894 80.6181C30.159 78.6116 32.4742 77.9942 34.4808 77.8399C34.0177 79.5377 33.709 80.6181 33.709 80.6181L32.9373 83.8595L58.868 100.375L64.1158 92.8118L43.5874 79.5377Z`},
  //       {fill: `white`, d: `M60.2571 108.864L27.8437 88.0269L25.0654 89.7248C17.1936 94.5096 4.53695 108.092 13.3349 124.299C15.3414 127.849 15.9588 130.782 15.1871 132.325C14.4153 133.869 11.637 134.795 9.93918 134.949L5.77175 135.412L5 143.593L9.01309 144.828C11.3283 145.599 19.5088 148.069 28.7698 147.606C35.4068 147.297 42.5069 145.445 48.5266 140.66C63.6528 128.466 60.7202 111.797 60.7202 111.025L60.2571 108.864ZM42.0439 132.788C36.796 136.956 29.8503 137.727 23.985 137.419C24.1393 137.264 24.1393 137.11 24.1393 136.956C26.6089 132.171 25.9915 126.306 22.1328 119.36C17.348 110.562 23.985 103.308 27.9981 100.066L50.8418 114.729C50.8418 118.434 49.9157 126.46 42.0439 132.788Z`},
  //       {fill: `#ECECEC`, d: `M67.2028 102.073C67.2028 102.073 67.9746 101.455 69.2094 100.375C69.8268 102.227 70.1355 104.542 69.3637 107.321L75.6921 112.877C76.1551 112.723 88.3487 107.321 92.3618 96.2074C94.214 91.1139 94.214 85.5573 92.0531 80.0007C95.9118 76.2964 100.542 72.2833 106.408 63.331L99.6162 56.694C94.677 64.1027 87.577 71.3572 83.4095 75.5246L80.9399 77.8398L82.4834 80.9268C84.6443 85.403 85.1074 89.2617 83.7182 92.9661C82.6378 95.7444 80.7856 98.214 78.7791 99.9118C77.6986 95.127 75.0747 91.8857 73.5312 90.3422L70.4442 87.2552L67.2028 90.0335C65.968 91.1139 64.8876 92.04 63.9615 92.8117L57.3245 99.4488L64.5789 104.234L67.2028 102.073Z`},
  //       {fill: `#AFAFAF`, d: `M104.092 13.7848L103.012 9C103.012 9 102.086 9.15435 94.214 11.1609C94.214 11.4696 95.7575 20.4219 95.7575 20.4219C98.2271 34.0046 101.005 51.7548 99.6162 56.694C99.7706 63.0223 99.9249 72.1289 99.9249 72.1289L102.858 68.7332C106.562 64.5658 107.642 61.6332 108.26 59.4723C111.038 49.5939 105.173 19.6501 104.092 13.7848Z`}
  //     ]

  //   },
  //       {
  //     //Rocket-Gradation Gray
  //     viewBox: `0 0 114 156`,
  //     class: `mr-1 ml-2`,
  //     paths:[
  //       {fill: `#C90920`, d: `M95.9118 20.2675L103.166 9L95.9118 20.2675C95.7575 20.2675 95.9118 20.2675 95.9118 20.2675Z`},
  //       {fill: `url(#rocket0_gray)`, d: `M55.0092 25.5154C53.4657 26.9045 48.0635 31.2263 43.2787 48.3591L50.8418 54.9961C56.244 38.6351 60.5658 33.0785 61.1832 32.4611C65.3507 28.9111 82.9465 23.5089 95.9118 20.2675L103.012 9L98.3814 10.0804C92.5162 11.4696 62.8811 18.8784 55.0092 25.5154Z`},
  //       {fill: `url(#rocket1_gray)`, d: `M43.5874 79.5377C43.8961 78.4573 44.2048 76.9138 44.6678 75.3703L45.7483 71.3572L41.8895 69.8137C39.883 69.0419 35.5612 67.8071 30.622 68.8876C31.3938 66.2636 32.7829 63.6397 34.9438 61.4788C37.7221 58.7005 41.5808 57.4657 46.52 57.6201L49.9157 57.7744L52.8483 49.1309C51.9222 48.8222 47.9092 48.2048 43.2787 48.5135C37.259 48.9765 32.3199 51.1374 28.4611 54.9961C19.9719 63.331 20.1263 76.6051 20.1263 77.2225L27.6894 80.6181C30.159 78.6116 32.4742 77.9942 34.4808 77.8399C34.0177 79.5377 33.709 80.6181 33.709 80.6181L32.9373 83.8595L58.868 100.375L64.1158 92.8118L43.5874 79.5377Z`},
  //       {fill: `url(#rocket2_gray)`, d: `M60.2571 108.864L27.8437 88.0269L25.0654 89.7248C17.1936 94.5096 4.53695 108.092 13.3349 124.299C15.3414 127.849 15.9588 130.782 15.1871 132.325C14.4153 133.869 11.637 134.795 9.93918 134.949L5.77175 135.412L5 143.593L9.01309 144.828C11.3283 145.599 19.5088 148.069 28.7698 147.606C35.4068 147.297 42.5069 145.445 48.5266 140.66C63.6528 128.466 60.7202 111.797 60.7202 111.025L60.2571 108.864ZM42.0439 132.788C36.796 136.956 29.8503 137.727 23.985 137.419C24.1393 137.264 24.1393 137.11 24.1393 136.956C26.6089 132.171 25.9915 126.306 22.1328 119.36C17.348 110.562 23.985 103.308 27.9981 100.066L50.8418 114.729C50.8418 118.434 49.9157 126.46 42.0439 132.788Z`},
  //       {fill: `url(#rocket3_gray)`, d: `M67.2028 102.073C67.2028 102.073 67.9746 101.455 69.2094 100.375C69.8268 102.227 70.1355 104.542 69.3637 107.321L75.6921 112.877C76.1551 112.723 88.3487 107.321 92.3618 96.2074C94.214 91.1139 94.214 85.5573 92.0531 80.0007C95.9118 76.2964 100.542 72.2833 106.408 63.331L99.6162 56.694C94.677 64.1027 87.577 71.3572 83.4095 75.5246L80.9399 77.8398L82.4834 80.9268C84.6443 85.403 85.1074 89.2617 83.7182 92.9661C82.6378 95.7444 80.7856 98.214 78.779 99.9118C77.6986 95.127 75.0747 91.8857 73.5312 90.3422L70.4442 87.2552L67.2028 90.0335C65.968 91.1139 64.8876 92.04 63.9615 92.8117L57.3245 99.4488L64.5789 104.234L67.2028 102.073Z`},
  //       {fill: `url(#rocket4_gray)`, d: `M104.092 13.7848L103.012 9C103.012 9 102.086 9.15435 94.214 11.1609C94.214 11.4696 95.7575 20.4219 95.7575 20.4219C98.2271 34.0046 101.005 51.7548 99.6162 56.694C99.7706 63.0223 99.9249 72.1289 99.9249 72.1289L102.858 68.7332C106.562 64.5658 107.642 61.6332 108.26 59.4723C111.038 49.5939 105.173 19.6501 104.092 13.7848Z`}
  //       ],
  //     linearGradients:[
  //       {id: `rocket0_gray`, x1: `43.2917`, x2: `103.085`, y1: `32.0794`, y2: `32.0783`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#D9D9D9`},
  //           {color: `#B9B9B9`, offset: "1"}
  //         ]
  //       },
  //       {id: `rocket1_gray`, x1: `20.1378`, x2: `64.1587`, y1: `74.4164`, y2: `74.4155`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#868686`},
  //           {color: `#606060`, offset: "1"}
  //         ]
  //       },
  //       {id: `rocket2_gray`, x1: `4.99889`, x2: `60.8706`, y1: `117.824`, y2: `117.824`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `white`},
  //           {color: `#CACACA`, offset: "1"}
  //         ]
  //       },
  //       {id: `rocket3_gray`, x1: `98.9774`, x2: `68.637`, y1: `56.2366`, y2: `108.79`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#ECECEC`, offset: "0.4634"},
  //           {color: `#BCBCBC`, offset: "1"}
  //         ]
  //       },
  //       {id: `rocket4_gray`, x1: `101.632`, x2: `101.632`, y1: `9`, y2: `71.9477`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#AFAFAF`},
  //           {color: `#878787`, offset: "1"}

  //         ]
  //       }
  //     ]

  //   },
  //   {
  //     //ROCKET SIMPLE
  //     class: `mr-1 ml-2`,
  //     viewBox: `0 0 59 81`,
  //     paths:[
  //       {fill: `#C90920`, d: `M27.392 45.117L24.7179 49.2779L24.749 49.2979L27.4231 45.1369L27.392 45.117Z`},
  //       {fill: `#C90920`, d: `M49.9896 10.0531L53.8664 4.03691V4L49.9896 10.0531Z`},
  //       {fill: `#00A099`, d: `M28.2059 12.8213C27.3567 13.5595 24.5138 15.9217 21.8923 25.0383L25.9168 28.5816C28.7597 19.8341 31.0858 16.8444 31.4181 16.5861C33.6334 14.6668 43.0484 11.8248 49.9158 10.0531L53.8664 4L51.3557 4.59055C48.2174 5.36564 32.3411 9.27802 28.2059 12.8213Z`},
  //       {fill: `#C90920`, d: `M22.1139 41.6843C22.2616 41.0569 22.4831 40.3187 22.7046 39.4329L23.2954 37.2921L21.2278 36.4801C20.1201 36.0372 17.8679 35.4098 15.2095 36.0003C15.6526 34.6347 16.3541 33.1583 17.4987 32.0141C19.0125 30.5378 21.0062 29.8734 23.6277 29.9472L25.4737 30.021L27.0614 25.4074C26.5445 25.2228 24.3661 24.8906 21.9293 25.0383C18.754 25.2966 16.0587 26.4408 13.9911 28.5077C9.48671 32.9738 9.56055 40.0234 9.56055 40.3556L13.6219 42.2011C14.9142 41.1307 16.1695 40.7616 17.2033 40.7247C16.9449 41.6474 16.8341 42.2011 16.8341 42.2011L16.391 43.9358L30.2735 52.794L33.0796 48.734L22.1139 41.6843Z`},
  //       {fill: `#F7BC00`, d: `M30.9381 57.297L13.6588 46.1873L12.2189 47.0731C7.97293 49.6937 1.17937 56.9279 5.94224 65.5646C6.97605 67.4839 7.34526 69.0341 6.93913 69.8461C6.49607 70.695 5.01921 71.1379 4.17001 71.2117L1.99164 71.4332L1.47474 75.8254L3.57927 76.5267C4.8346 76.9327 9.19134 78.2245 14.1019 77.9661C17.6464 77.7816 21.4493 76.8589 24.6615 74.2383C32.7473 67.7054 31.1966 58.8102 31.1596 58.4411L30.9381 57.297ZM21.2647 70.0676C18.4956 72.319 14.7665 72.725 11.6282 72.5405C11.6651 72.4667 11.702 72.3928 11.7389 72.319C13.0681 69.7723 12.6989 66.635 10.6682 62.9441C8.04677 58.1828 11.5912 54.3442 13.6958 52.6095L25.8799 60.4712C25.9537 62.4273 25.4737 66.6719 21.2647 70.0676Z`},
  //       {fill: `#E84E1B`, d: `M34.6672 53.6429C34.6672 53.6429 35.0733 53.3108 35.7379 52.7571C36.1071 53.7168 36.2548 54.9348 35.8118 56.485L39.1716 59.4008C39.4301 59.2901 45.8913 56.448 48.1066 50.4687C49.1035 47.7006 49.0666 44.8216 47.9959 41.7951C50.0265 39.802 52.5741 37.6612 55.6755 32.8999L52.0203 29.3567C49.362 33.269 45.6329 37.2183 43.3438 39.396L42.0146 40.6509L42.8268 42.2749C43.9714 44.6371 44.1929 46.7409 43.4914 48.6971C42.9376 50.2104 41.9038 51.4653 40.8331 52.4249C40.2793 49.8413 38.8393 48.1066 38.0271 47.2946L36.4025 45.6705L34.6672 47.1469C34.0026 47.7006 33.4119 48.1804 32.9319 48.5864L29.3874 52.1297L33.3011 54.6764L34.6672 53.6429Z`},
  //       {fill: `#93C01F`, d: `M54.3833 6.50983L53.8664 4C53.8664 4 53.3495 4.07382 49.1773 5.14419C49.2143 5.29182 50.0265 10.0531 50.0265 10.0531C51.3557 17.2873 52.8326 26.773 52.0572 29.3936C52.1311 32.7892 52.2049 37.5874 52.2049 37.5874L53.7556 35.742C55.7124 33.5274 56.3032 31.9034 56.5986 30.7961C58.1123 25.6657 55.0109 9.68402 54.3833 6.50983Z`}

  //     ]

  //   },
  //   {
  //     //Rocket-Gradation
  //     viewBox: `0 0 59 81`,
  //     class: `mr-1 ml-2`,
  //     paths:[
  //       {fill: `#C90920`, d: `M27.67 45.0948L25.0214 49.2535L25.0521 49.2734L27.7007 45.1147L27.67 45.0948Z`},
  //       {fill: `#C90920`, d: `M50.0519 10.0498L53.8916 4.03689V4L50.0519 10.0498Z`},
  //       {fill: `url(#rocket0)`, d: `M28.4761 12.8166C27.635 13.5543 24.8191 15.9153 22.2227 25.0269L26.2088 28.5683C29.0246 19.8255 31.3285 16.8375 31.6576 16.5793C33.8517 14.661 43.1769 11.8205 49.9787 10.0499L53.8916 4L51.4049 4.59023C48.2965 5.36491 32.5718 9.27517 28.4761 12.8166Z`},
  //       {fill: `url(#rocket1)`, d: `M22.4422 41.664C22.5884 41.0369 22.8078 40.2991 23.0273 39.4138L23.6124 37.2742L21.5645 36.4626C20.4674 36.0199 18.2367 35.3928 15.6037 35.9831C16.0426 34.6181 16.7374 33.1426 17.871 31.999C19.3703 30.5234 21.3451 29.8594 23.9415 29.9332L25.7699 30.007L27.3424 25.3958C26.8305 25.2114 24.6729 24.8794 22.2593 25.0269C19.1144 25.2851 16.4448 26.4287 14.3969 28.4945C9.93551 32.9581 10.0086 40.004 10.0086 40.336L14.0313 42.1805C15.3112 41.1107 16.5545 40.7418 17.5785 40.7049C17.3225 41.6271 17.2128 42.1805 17.2128 42.1805L16.7739 43.9143L30.5239 52.7677L33.3032 48.7099L22.4422 41.664Z`},
  //       {fill: `url(#rocket2)`, d: `M31.1822 57.2682L14.0678 46.1645L12.6416 47.0499C8.43617 49.669 1.70745 56.8993 6.42487 65.5314C7.4488 67.4497 7.81449 68.999 7.41223 69.8106C6.9734 70.659 5.51064 71.1017 4.66955 71.1755L2.51197 71.3968L2 75.7866L4.08444 76.4875C5.32779 76.8933 9.64295 78.1844 14.5066 77.9262C18.0173 77.7418 21.7839 76.8195 24.9654 74.2004C32.9741 67.671 31.4382 58.7807 31.4016 58.4118L31.1822 57.2682ZM21.6011 70.0319C18.8584 72.2822 15.1649 72.6879 12.0565 72.5035C12.0931 72.4297 12.1297 72.3559 12.1662 72.2822C13.4827 69.7368 13.117 66.6012 11.1057 62.9123C8.50931 58.1535 12.0199 54.3171 14.1044 52.5833L26.1722 60.4407C26.2453 62.3958 25.7699 66.6381 21.6011 70.0319Z`},
  //       {fill: `url(#rocket3)`, d: `M34.8757 53.6161C34.8757 53.6161 35.2779 53.2841 35.9362 52.7308C36.3019 53.6899 36.4481 54.9073 36.0093 56.4566L39.3371 59.3709C39.5931 59.2602 45.9927 56.4197 48.1868 50.4437C49.1742 47.677 49.1376 44.7996 48.0771 41.7747C50.0884 39.7827 52.6117 37.6431 55.6835 32.8843L52.0632 29.343C49.4302 33.2532 45.7367 37.2004 43.4694 39.3769L42.1529 40.6311L42.9575 42.2542C44.0911 44.6152 44.3105 46.7178 43.6157 48.673C43.0672 50.1854 42.0432 51.4397 40.9827 52.3988C40.4342 49.8165 39.008 48.0828 38.2035 47.2712L36.5944 45.6481L34.8757 47.1236C34.2174 47.677 33.6323 48.1565 33.1569 48.5623L29.6463 52.1037L33.5226 54.6491L34.8757 53.6161Z`},
  //       {fill: `url(#rocket4)`, d: `M54.4036 6.50847L53.8916 4C53.8916 4 53.3797 4.07378 49.2473 5.14357C49.2839 5.29113 50.0884 10.0498 50.0884 10.0498C51.4049 17.2802 52.8677 26.7607 52.0997 29.3799C52.1729 32.7737 52.246 37.5693 52.246 37.5693L53.7819 35.7248C55.7201 33.5115 56.3052 31.8883 56.5977 30.7817C58.0971 25.654 55.0253 9.68096 54.4036 6.50847Z`},
  //     ],
  //     linearGradients:[
  //       {id: `rocket0`, x1: `22.2552`, x2: `53.8868`, y1: `16.3034`, y2: `16.3028`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#00A099`},
  //           {color: `#2D2E82`, offset: "1"}
  //         ]
  //       },
  //       {id: `rocket1`, x1: `10.0065`, x2: `33.2942`, y1: `38.8964`, y2: `38.896`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#C90920`},
  //           {color: `#A0122A`, offset: "1"}
  //         ]
  //       },
  //       {id: `rocket2`, x1: `1.99979`, x2: `31.5567`, y1: `62.074`, y2: `62.074`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#F7BC00`},
  //           {color: `#D8A209`, offset: "1"}
  //         ]
  //       },
  //       {id: `rocket3`, x1: `51.7138`, x2: `35.4525`, y1: `29.1948`, y2: `57.1168`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#E84E1B`, offset: "0.4634"},
  //           {color: `#BA3F1E`, offset: "1"}
  //         ]
  //       },
  //       {id: `rocket4`, x1: `53.1195`, x2: `53.1195`, y1: `4`, y2: `37.5918`, gradientUnits: `userSpaceOnUse`,
  //         stops:[
  //           {color: `#93C01F`},
  //           {color: `#008D36`, offset: "1"}

  //         ]
  //       }
  //     ]

  //   }
  // ];

  // let logoIndex = 0;
  // let logoTextIndex = 1;

  // let logoText = logoTexts[logoTextIndex];
  // let logo = logos[logoIndex];

  // const getLogo = () => {
  //   logoIndex = logoIndex + 1;
  //   if(logoIndex > (logos.length - 1))
  //     logoIndex = 0;
  //   logo = logos[logoIndex];
  // }

  // const getLogoText = () =>{
  //   logoTextIndex = logoTextIndex + 1;
  //       if(logoTextIndex > (logoTexts.length - 1))
  //         logoTextIndex = 0;
  //       logoText = logoTexts[logoTextIndex];
  // }
</script>

<style>
  button {
    height: 48px;
    @apply text-left;
  }
  /* 
    img{
        width: 32px;
        max-width: 100%;
        height: auto;
    } */
</style>

<div
  class="bg-smfBlack-200"
  class:flex={!isMobile}
  class:flex-col={!isMobile}
  class:w-64={!isMobile && isExpand}
  class:w-10={!isMobile && !isExpand}
  class:h-0={isMobile}
  class:flex-1={isMobile}
  class:overflow-y-auto={isMobile}
  class:pb-4={isMobile}
  transition:fly>
  <div
    class:h-0={!isMobile}
    class:flex-1={!isMobile}
    class:overflow-y-auto={!isMobile}
    class:pb-4={!isMobile}>
    <div
      class="flex-shrink-0 flex items-center p-4 bg-smfBlack-100"
      style="min-height:64px">
      <!-- <img class="h-8 w-auto" src="{src}" alt="smf" /> -->
      <!-- <div on:click={getLogo} class={logo.class}>
            <svg class="w-6" viewBox={logo.viewBox} fill="none">
              {#each logo.paths as entry}
                <path d="{entry.d}" fill={entry.fill}/>
              {/each}
              {#if logo.linearGradients != null}
                <defs>
                {#each logo.linearGradients as lg}
                  <linearGradient id={lg.id} x1={lg.x1} y1={lg.y1} x2={lg.x2} y2={lg.y2} gradientUnits={lg.gradientUnits}>
                    {#each lg.stops as stop}
                      {#if stop.offest != null}
                      <stop stop-color={stop.color}/>
                      {:else}
                      <stop offset={stop.offset} stop-color={stop.color}/>
                      {/if}
                    {/each}
                  </linearGradient>
                {/each}
                </defs>
              {/if}
            </svg>
          </div>
          <div on:click={getLogoText}>
            <svg class="h-6" viewBox={logoText.viewBox} fill="none">
                    {#each logoText.paths as entry}
                    <path d="{entry}" fill="white"/>
                    {/each}
            </svg>
          </div> -->
      <!-- <span>GetItOut</span> -->
      <svg class="h-6" viewBox="0 0 200 185" fill="none">
        <path
          d="M167.432 37.4372H30.344C26.672 37.4372 23 35.0023 23
          31.3498V14.3049C23 10.6525 26.672 7 30.344 7H168.656C172.328 7 176
          10.6525 176 14.3049V31.3498C176 36.5183 172.328 37.4372 167.432
          37.4372Z"
          fill="white" />
        <path
          d="M167.432 178.666H30.344C26.672 178.666 23 175.014 23
          171.361V154.316C23 150.664 26.672 147.011 30.344
          147.011H168.656C172.328 147.011 176 150.664 176 154.316V171.361C176
          176.018 172.328 178.666 167.432 178.666Z"
          fill="#ECECEC" />
        <path
          d="M57.272 84.9193H30.344C26.672 84.9193 23 82.4843 23
          78.8319V61.787C23 58.1346 26.672 54.4821 30.344 54.4821H58.496C62.168
          54.4821 65.84 58.1346 65.84 61.787V78.8319C65.84 83.5183 62.168
          84.9193 57.272 84.9193Z"
          fill="#868686" />
        <path
          d="M57.272 132.401H30.344C26.672 132.401 23 128.749 23
          125.096V108.052C23 104.399 26.672 100.747 30.344 100.747H58.496C62.168
          100.747 65.84 104.399 65.84 108.052V125.096C65.84 130.018 62.168
          132.401 57.272 132.401Z"
          fill="#AFAFAF" />
        <path
          d="M112.352 132.401H85.424C81.752 132.401 78.08 128.749 78.08
          125.096V108.052C78.08 104.399 81.752 100.747 85.424
          100.747H113.576C117.248 100.747 120.92 104.399 120.92
          108.052V125.096C120.92 129.018 117.248 132.401 112.352 132.401Z"
          fill="#868686" />
        <path
          d="M167.432 132.401H140.504C136.832 132.401 133.16 128.749 133.16
          125.096V108.052C133.16 104.399 136.832 100.747 140.504
          100.747H168.656C172.328 100.747 176 104.399 176 108.052V125.096C176
          130.018 172.328 132.401 167.432 132.401Z"
          fill="#B1B1B1" />
        <path
          d="M167.432 84.9193H85.424C81.752 84.9193 78.08 81.2669 78.08
          77.6144V61.787C78.08 58.1346 81.752 54.4821 85.424
          54.4821H168.656C172.328 54.4821 176 58.1346 176 61.787V78.8319C176
          83.0183 172.328 84.9193 167.432 84.9193Z"
          fill="#D9D9D9" />
      </svg>
      <svg class="h-6" viewBox="0 0 978 185" fill="none">
        <path
          d="M127.854 145.541C117.281 155.954 103.823 161.634 89.4042
          161.634C80.7529 161.634 72.1016 159.741 64.4115 155.954C56.7215
          152.167 49.9927 147.434 44.2251 141.754C38.4576 135.127 33.6513 128.5
          30.7675 119.98C27.8838 111.46 25 101.993 25 92.5267C25 83.0599 26.9225
          74.5398 29.8063 66.0197C33.6513 58.4463 38.4576 50.8729 44.2251
          45.1928C49.9927 39.5128 57.6827 33.8327 65.3728 30.9927C73.0628
          28.1526 82.6754 25.3126 91.3267 25.3126C103.823 25.3126 115.358
          28.1526 124.009 32.886C133.622 38.5661 140.351 45.1928 144.196
          54.6596L124.009 68.8598C120.164 62.233 115.358 57.4996 109.591
          53.7129C104.784 49.9262 98.0555 48.0328 90.3655 48.0328C84.5979
          48.0328 79.7916 48.9795 74.9853 51.8196C70.1791 53.7129 65.3728
          57.4996 62.489 61.2863C58.644 66.0197 56.7215 70.7531 54.799
          76.4332C52.8764 82.1132 51.9152 86.8466 51.9152 93.4734C51.9152 100.1
          52.8764 105.78 54.799 111.46C56.7215 117.14 59.6052 121.874 63.4503
          125.66C67.2953 129.447 71.1403 133.234 75.9466 135.127C80.7529 137.021
          86.5204 137.967 92.288 137.967C105.746 137.967 117.281 132.287 127.854
          119.98V110.514H99.978V91.58H149.963V160.687H127.854V145.541Z"
          fill="white" />
        <path
          d="M267.237
          137.967V160.687H172.072V26.2593H265.314V48.9795H198.987V81.1665H256.663V101.993H198.987V137.02H267.237V137.967Z"
          fill="white" />
        <path
          d="M390.277
          48.9795H347.021V160.687H321.067V48.9795H277.81V26.2593H390.277V48.9795Z"
          fill="white" />
        <path
          d="M608.483 161.634C598.87 161.634 589.258 159.741 581.568
          155.954C573.878 152.167 566.188 147.434 560.42 140.807C554.652 134.18
          549.846 127.554 546.962 119.034C544.079 110.514 542.156 101.993
          542.156 93.4734C542.156 84.9533 544.079 75.4865 546.962
          67.9131C550.807 59.393 554.652 52.7662 561.381 46.1395C567.149 39.5128
          574.839 34.7794 582.529 30.9927C591.18 27.2059 599.831 25.3126 609.444
          25.3126C619.057 25.3126 628.669 27.2059 636.359 30.9927C644.049
          34.7794 651.739 40.4594 657.507 46.1395C663.274 51.8196 668.081
          60.3397 670.964 67.9131C673.848 76.4332 675.771 84.0066 675.771
          92.5267C675.771 101.047 673.848 110.514 670.964 118.087C668.081 125.66
          663.274 133.234 657.507 139.861C651.739 146.487 645.011 151.221
          636.359 155.007C626.747 159.741 618.095 161.634 608.483
          161.634ZM569.071 93.4734C569.071 99.1534 570.033 104.833 571.955
          110.514C573.878 116.194 576.761 120.927 579.645 124.714C583.49 128.5
          587.335 132.287 592.141 135.127C596.948 137.967 602.715 138.914
          609.444 138.914C616.173 138.914 621.94 137.967 626.747 135.127C631.553
          132.287 635.398 129.447 639.243 124.714C643.088 119.98 645.011 115.247
          646.933 110.514C648.856 104.833 649.817 100.1 649.817 94.42C649.817
          88.74 648.856 83.0599 646.933 77.3798C645.011 71.6998 642.127 66.9664
          639.243 63.1797C636.359 59.393 629.63 54.6596 624.824 51.8196C620.018
          48.9795 614.25 48.0328 608.483 48.0328C601.754 48.0328 595.986 48.9795
          591.18 51.8196C586.374 54.6596 581.568 57.4996 578.684 62.233C575.8
          66.0197 572.916 71.6998 570.994 76.4332C569.071 82.1132 569.071
          87.7933 569.071 93.4734Z"
          fill="white" />
        <path
          d="M752.671 137.967C759.4 137.967 764.206 137.02 768.052
          134.18C771.897 131.34 775.742 128.5 778.625 124.714C781.509 120.927
          783.432 116.194 784.393 110.514C785.354 104.833 786.315 100.1 786.315
          94.42V26.2593H813.231V94.42C813.231 103.887 812.269 112.407 809.386
          119.98C807.463 128.5 803.618 135.127 798.812 140.807C794.005 146.487
          788.238 151.221 780.548 155.007C772.858 158.794 764.206 160.687
          753.633 160.687C743.059 160.687 733.446 158.794 725.756
          155.007C718.066 151.221 712.299 146.487 707.492 139.861C702.686 134.18
          699.802 126.607 696.918 118.087C694.996 109.567 694.035 101.993
          694.035 92.5267V26.2593H720.95V94.42C720.95 100.1 721.911 105.78
          722.872 110.514C723.834 115.247 725.756 119.98 728.64 124.714C731.524
          129.447 734.408 132.287 739.214 134.18C742.098 137.02 746.904 137.967
          752.671 137.967Z"
          fill="white" />
        <path
          d="M942.039
          48.9795H898.782V160.687H872.828V48.9795H829.572V26.2593H943V48.9795H942.039Z"
          fill="white" />
        <path
          d="M429.689 63.1797H446.992L425.844 161.634H408.541L429.689
          63.1797ZM438.34 23.4192H455.643L450.837 44.2461H433.534L438.34
          23.4192Z"
          fill="white" />
        <path
          d="M478.713 162.581C473.907 162.581 469.1 161.634 466.217
          158.794C462.372 155.954 461.41 152.167 461.41 147.434C461.41 145.541
          461.41 143.647 462.372 141.754L476.791 75.4865H463.333L466.217
          62.233H478.713L485.442 29.0993H502.744L496.016 62.233H517.163L514.28
          75.4865H493.132L478.713 137.02C478.713 137.967 478.713 138.914 478.713
          139.861C478.713 142.701 479.674 144.594 481.597 145.541C483.519
          146.487 485.442 147.434 487.364 147.434C490.248 147.434 493.132
          146.487 496.016 145.541C498.899 144.594 500.822 143.647 501.783
          142.701L502.744 155.954C500.822 157.847 496.977 158.794 492.171
          160.687C488.326 162.581 483.519 162.581 478.713 162.581Z"
          fill="white" />
      </svg>
    </div>
    <div
      class="w-full flex flex-row flex-1 px-2 bg-smfBlack-200"
      class:py-2={!isExpand}>
      {#if isExpand}
        <div
          class="group flex flex-grow items-center px-2 py-2 text-base leading-6
          font-medium text-white hover:bg-smfBlack-100 focus:outline-none
          transition ease-in-out duration-150"
          in:fly={{ delay: 100, duration: 300, easing: quintOut }}
          out:fly={{ delay: 0, duration: 0, easing: quintOut }}>
          <ProductMenu />
        </div>
        <!-- <div class="group flex items-center px-2 py-2 text-base leading-6 font-medium text-white bg-smfBlack-100 focus:outline-none transition ease-in-out duration-150">
              <Navigate to="/createProduct">
                <span class="text-white text-2xl">+</span>
              </Navigate>
            </div> -->
      {:else if $currentProduct != null}
        {#if $currentProduct.file == null}
          <svg
            class="h-6 w-6 transition ease-in-out duration-150"
            fill={product.fill}
            viewBox={product.viewBox}>
            <path d={product.d} fill={product.pathFill} />
          </svg>
        {:else}
          <Image
            src={$currentProduct.file}
            class="h-auto w-6 transition ease-in-out duration-150" />
        {/if}
      {:else}
        <svg
          class="h-6 w-6 transition ease-in-out duration-150"
          fill={product.fill}
          viewBox={product.viewBox}>
          <path d={product.d} fill={product.pathFill} />
        </svg>
      {/if}

    </div>
    <nav class="flex-1 bg-smfBlack-200">
      <div>
        {#each nav as group}
          <div
            style="border-bottom: 0.5px solid #242424"
            class="py-2"
            class:px-2={isExpand}>
            <div class="flex flex-row py-2" class:px-2={isExpand}>
              {#if isExpand}
                <span class="h-6 w-6" class:mr-3={isExpand} />
                <h4
                  style="color:#D1D3D4; font-weight:800;"
                  class="text-m"
                  in:fly={{ delay: 100, duration: 400, easing: quintOut }}
                  out:fly={{ delay: 0, duration: 0, easing: quintOut }}>
                  {group.name}
                </h4>
              {:else}
                <h4
                  class:m-auto={!isExpand}
                  style="color:#D1D3D4; font-weight:800;"
                  class="text-m"
                  in:fly={{ delay: 100, duration: 400, easing: quintOut }}
                  out:fly={{ delay: 0, duration: 0, easing: quintOut }}>
                  {group.shortCode}
                </h4>
              {/if}
            </div>
            {#each group.items as item}
              <a
                style="color:#8D8D8D; font-weight:500;"
                on:click|preventDefault={() => {
                  goTo(item);
                }}
                href="{item.link.first}{item.link.second != null ? ($currentProduct != null ? $currentProduct.uid : '') + item.link.second : ''}"
                class:px-2={isExpand}
                class="group flex items-center py-2 text-sm leading-5
                font-medium rounded-md bg-smfBlack-200 focus:outline-none
                focus:bg-smfBlack-100 hover:bg-smfBlack-100 transition
                ease-in-out duration-150">
                <svg
                  class="h-6 w-6 transition ease-in-out duration-150"
                  class:mr-3={isExpand}
                  class:m-auto={!isExpand}
                  fill={item.svg.fill}
                  viewBox={item.svg.viewBox}>
                  <path
                    fill-rule={item.svg.fillRule}
                    clip-rule={item.svg.clipRule}
                    d={item.svg.d}
                    fill={item.svg.pathFill} />
                  {#if item.svg.secondPath != null}
                    <path
                      d={item.svg.secondPath.d}
                      fill={item.svg.secondPath.pathFill} />
                  {/if}
                </svg>
                {#if isExpand}
                  <span
                    in:fly={{ delay: 100, duration: 400, easing: quintOut }}
                    out:fly={{ delay: 0, duration: 0, easing: quintOut }}>
                    {item.name}
                  </span>
                  {#if item.isSoon}
                    <Badge class="ml-2">SOON</Badge>
                  {/if}
                {/if}
              </a>
            {/each}
          </div>
        {/each}
      </div>

    </nav>
  </div>
  {#if isExpand}
    <div
      class="flex-shrink-0 flex bg-smfBlack-200 p-4"
      in:fly={{ delay: 100, duration: 400, easing: quintOut }}
      out:fly={{ delay: 0, duration: 0, easing: quintOut }}>
      <a href="#" class="flex-shrink-0 group block focus:outline-none">
        <div class="flex items-center">
          <!-- <div>
              <img class="inline-block h-9 w-9 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="" />
            </div> -->
          <div class="ml-3">
            <p class="text-sm leading-5 font-medium text-white">Free Plan</p>
            <p
              class="text-xs leading-4 font-medium text-gray-400
              group-hover:text-gray-300 group-focus:underline transition
              ease-in-out duration-150">
              One output Format included
            </p>
          </div>
        </div>
      </a>
    </div>
  {/if}
  {#if !isMobile}
    <button
      type="button"
      class="py-2 px-3 w-full flex flex-row text-white focus:outline-none"
      on:click={() => {
        isExpand = !isExpand;
      }}>
      <span class="flex-grow" />
      {#if isExpand}
        <Icon data={faChevronLeft} />
      {:else}
        <Icon data={faChevronRight} />
      {/if}
    </button>
  {/if}
</div>
